<template>
    <ItemMenuWrapper v-slot="{ inputId }" :label="label">
        <Button :id="inputId" @click="abrirModal" label="Abrir Painel de Edição" icon="pi pi-arrow-up-left" editorStyle="height: 250px" />
    </ItemMenuWrapper>

    <Dialog v-model:visible="mostrarModal" modal header="Editor de Texto" style="width: 80vw">
        <Editor
            v-if="hackMostrarEditor"
            :key="hackKeyEditor"
            :modelValue="modelValue"
            :id="inputId"
            @update:modelValue="handleUpdate"
            editorStyle="height: 200px"
        />
        <template #footer>
            <Button @click="fecharModal" label="Fechar" />
        </template>
    </Dialog>
</template>

<script setup>
import ItemMenuWrapper from './ItemMenuWrapper.vue';
import { defineEmits, defineProps, ref, nextTick } from 'vue';

defineProps({
    label: {
        type: String,
    },
    modelValue: {
        type: String,
        default: '',
    },
});

const mostrarModal = ref(false);

const hackMostrarEditor = ref(false);
const hackKeyEditor = ref(0);

async function abrirModal() {
    mostrarModal.value = true;

    await nextTick();

    hackMostrarEditor.value = true;
}
async function fecharModal() {
    hackMostrarEditor.value = false;

    await nextTick();

    hackKeyEditor.value++;

    mostrarModal.value = false;
}

const emit = defineEmits(['update:modelValue']);
const handleUpdate = (value) => {
    emit('update:modelValue', value);
};
</script>
